<script setup lang="ts">
import { PropType } from 'vue'
import Menu from './Menu/index.vue'
import { AvionLocation } from '@/entities/AvionLocation'
import Skeleton from 'primevue/skeleton'

defineProps({
  title: {
    type: String,
    required: true,
  },
  location: {
    type: Object as PropType<AvionLocation>,
    required: false,
  },
})
</script>

<template>
  <div class="page">
    <Menu />
    <aside>
      <h1>{{ title }}</h1>
      <div v-if="location" class="location">
        <span>{{ location?.name }}</span>
        <i
          class="pi"
          :class="`pi-info-circle`"
          v-tooltip="{ value: location?.full_address || String(location?.pid) }"
        ></i>
      </div>
      <Skeleton v-else />
      <slot name="sidebar"></slot>
    </aside>
    <main>
      <slot name="main"></slot>
    </main>
  </div>
</template>

<style scoped>
.page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row;
  background-color: #f5f5f5;
  overflow-y: hidden;
}
aside {
  padding: var(--section-padding);
  overflow-y: auto;
  width: 300px;
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: var(--section-padding);
}
main {
  overflow-y: auto;
  flex: 1;
  background-color: #fff;
  position: relative;
}
.location {
  display: flex;
  align-items: center;
  gap: 8px;
}
.location span {
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
h1 {
  font-size: 20px;
  font-weight: 700;
}
</style>
